import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '../views/IndexView.vue'

Vue.use(VueRouter)

const routes =[
  {
    path: '/',
    name: 'home',
    component: IndexView
  },
  {
    path: '/index',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/IndexView.vue')
  },  {
    path: '/free',
    name: 'free',
    component: () => import(/* webpackChunkName: "about" */ '../views/FreeView.vue')
  },
  {
    path: '/one',
    name: 'one',
    component: () => import(/* webpackChunkName: "about" */ '../views/OneView.vue')
  },
  {
    path: '/two',
    name: 'two',
    component: () => import(/* webpackChunkName: "about" */ '../views/TwoView.vue')
  },
  {
    path: '/tree',
    name: 'tree',
    component: () => import(/* webpackChunkName: "about" */ '../views/TreeView.vue')
  },
  {
    path: '/call',
    name: 'call',
    component: () => import(/* webpackChunkName: "about" */ '../views/CallView.vue')
  },
  {
    path: '/massage',
    name: 'massage',
    component: () => import(/* webpackChunkName: "about" */ '../views/MassageView.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductView.vue')
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import(/* webpackChunkName: "about" */ '../views/PayView.vue')
  },
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

